import { render } from "./Changelog.vue?vue&type=template&id=09f1e5e0&scoped=true&ts=true"
import script from "./Changelog.vue?vue&type=script&lang=ts"
export * from "./Changelog.vue?vue&type=script&lang=ts"

import "./Changelog.vue?vue&type=style&index=0&id=09f1e5e0&lang=scss&scoped=true"

import exportComponent from "/home/issa/hcpet/hcpet-kasse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09f1e5e0"]])

export default __exports__